// extracted by mini-css-extract-plugin
export var banner = "_gh-0";
export var closeButton = "_gh-2";
export var greenCheckmark = "_gh-3";
export var hereLink = "_gh-4";
export var titleIcon = "_gh-1";